import PropTypes from "prop-types";

export default {
  /**
   * Indica si la fecha del campo irá con la primera hora del día
   */
  isStart: PropTypes.bool,
  /**
   * Indica si la fecha del campo irá con la última hora del día
   */
  isEnd: PropTypes.bool,
  /**
   * Id del campo
   */
  id: PropTypes.string,
  /**
   * Nombre del campo
   */
  name: PropTypes.string,
  /**
   * Formato de fecha a utilizar
   */
  dateFormat: PropTypes.string,
  /**
   * Etiqueta opcional para el campo
   */
  label: PropTypes.string,
  /**
   * Valor por defecto del campo
   */
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /**
   * Función que se ejecuta al cambiar el valor del campo
   */
  onChange: PropTypes.func,
  /**
   * Callback que se dispara con el cambio de foco
   */
  onBlur: PropTypes.func,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Indica si el campo lleva hora
   */
  withTime: PropTypes.bool,
  /**
   * Indica si el campo es de solamente hora
   */
  onlyTime: PropTypes.bool,
};
